import { JarvisAuthProvider } from '@jarvis/web-http';
import axios, { AxiosInstance } from 'axios';
import sendOpenTelemetryEvent from '../helpers/sendOpenTelemetryEvent';
import { SubscriptionStateResponse } from '../types/subscription';
import { Stack } from '@jarvis/web-stratus-client/dist/src/clients/stratus-client';
import getEnvironmentVariables from 'src/helpers/getEnvironmentVariables';
import { getStack } from 'src/helpers/getStack';

export interface PaymentMethods {
  [key: string]: any;
}

class SubscriptionClient {
  httpClient: AxiosInstance;
  mfeAuthProvider: JarvisAuthProvider;
  baseUrl: string;

  constructor(authProvider: JarvisAuthProvider, stack?: Stack) {
    this.httpClient = axios;
    this.mfeAuthProvider = authProvider;
    const env = getEnvironmentVariables(getStack(stack));
    this.baseUrl = env?.variables?.BASE_URL_PROVIDER ?? '';
  }

  async getSubscriptionById(
    subscriptionId: string
  ): Promise<SubscriptionStateResponse | null> {
    try {
      if (!subscriptionId) {
        throw new Error('Subscription ID is required');
      }

      const stratusToken = await this.mfeAuthProvider.getAccessToken();
      const headers = {
        accept: 'application/json',
        authorization: `Bearer ${stratusToken}`
      };

      const response = await this.httpClient.get(
        `${this.baseUrl}/subscription-state/v1/subscriptions/${subscriptionId}`,
        { headers }
      );

      return response.data || null;
    } catch (err: any) {
      if (err?.response?.status === 404) {
        return null;
      } else {
        sendOpenTelemetryEvent(
          `Error while fetching subscription ${subscriptionId} from subscription state api: ${err?.message}`
        );
        throw err;
      }
    }
  }

  async getPaymentMethods(paymentMethodId: string): Promise<PaymentMethods> {
    try {
      if (!paymentMethodId) {
        throw new Error('Payment method ID is required');
      }

      const stratusToken = await this.mfeAuthProvider.getAccessToken();
      const headers = {
        accept: 'application/json',
        authorization: `Bearer ${stratusToken}`
      };

      const response = await this.httpClient.get(
        `${this.baseUrl}/v1/payment-methods/${paymentMethodId}`,
        { headers }
      );

      return response.data;
    } catch (error: any) {
      sendOpenTelemetryEvent(
        `Error while fetching payment methods info from payment-methods api: ${JSON.stringify(error)}`
      );
      throw error;
    }
  }
}

export default SubscriptionClient;
